import React from 'react';

import { Button, Card, HStack, Separator, Text, ToggleTip, VStack } from '@betterment/samba-react';

interface Member {
  id: string;
  commonFirstName: string;
  portfolioControls: {
    securitiesLending: {
      enabled: boolean;
    };
  };
}

interface EditSecuritiesLendingCardProps {
  member: Member;
  handleOpenInviteModal: (memberId: string) => () => void;
}

export const EditSecuritiesLendingCard: React.FC<EditSecuritiesLendingCardProps> = ({
  member,
  handleOpenInviteModal,
}) => {
  const { id, commonFirstName, portfolioControls } = member;
  return (
    <Card
      key={id}
      css={{
        padding: 'space.300',
        border: '1px solid',
        borderColor: 'border',
      }}
    >
      <VStack css={{ gap: 'space.50' }}>
        <Text variant="text100" css={{ fontWeight: 'font-weight.semibold' }}>
          {commonFirstName}
        </Text>
        <Separator css={{ my: 'space.200' }} />
        <HStack css={{ justifyContent: 'space-between', alignItems: 'center' }}>
          <VStack>
            <HStack>
              <Text variant="text100" css={{ mr: 'space.100' }}>
                Securities lending
              </Text>
              <ToggleTip>
                <ToggleTip.Trigger iconName="InfoCircle" label="Securities lending" />
                <ToggleTip.Content css={{ maxWidth: '325px' }} align="center" side="top">
                  <Text>
                    Coming soon, enrolled clients can earn income by lending securities they own without selling or
                    giving up investment exposure. You can sell lent securities or opt clients out of the securities
                    lending program at any time.
                  </Text>
                </ToggleTip.Content>
              </ToggleTip>
            </HStack>
          </VStack>
          <VStack css={{ alignItems: 'end' }}>
            <Text>{portfolioControls.securitiesLending.enabled ? 'Enabled' : 'Disabled'}</Text>
            {!portfolioControls.securitiesLending.enabled && (
              <Button variant="textPrimary" onClick={handleOpenInviteModal(id)}>
                Send Invite
              </Button>
            )}
          </VStack>
        </HStack>
      </VStack>
    </Card>
  );
};
